const leftList = [
  {
    id: 1,
    title: "交易问题",
    list: [
      {
        ids: 1,
        title: "我拍下来后的商品什么时候发货？",
        des: `您成功后除特殊商品外，商家将在48小时内发货。以下情况除外：<br />
          1.预售及其他特殊情形商品，商品会在约定发货时间内安排发货，发货时间以商家商品描述页面为准<br />
          2.海淘直供类目产品，将在购买后7天内安排发货`
      },
      {
        ids: 3,
        title: "没有收到货/商家发错地址了怎么办？",
        des: `用户可进入 “我的订单”→点击对应订单→查看 “物流跟踪”，确认物流状态：​<br />
          1.若物流显示 “运输中”，且在正常配送周期内（普通商品默认 7 天，偏远地区 10 天，生鲜商品 3 天），可耐心等待，若超过正常周期仍无更新，可联系商家或物流公司咨询；​<br />
          2.若物流显示 “已签收”，但用户实际未收到货，需先检查是否为家人、邻居、小区驿站 / 快递柜代收，若确认无人代收，需立即联系商家处理。<br />
          若因商品问题商家拒绝处理，可以要求信悦臻选客服介入处理。`
      },
      {
        ids: 4,
        title: "收到商品有问题怎么办？",
        des: "买家可以先联系卖家客服，并提供实物图片确认问题是否属实。如果确认商品问题，或无法说明商品是否合格，卖家应与买家协商解决；若因商品问题商家拒绝处理，可以要求信悦臻选客服介入处理。"
      },
    ]
  },
  {
    id: 2,
    title: "规则中心",
    list: [
      {
        ids: 9,
        title: "用户服务协议",
        des: `个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本协议是您（或称"用户"）与信悦臻选商城之间就使用本系统服务所订立的契约。在注册或登录本系统前，请您仔细阅读本协议的全部内容，特别是协议中以加粗字体显示的内容，您应重点阅读。如您对协议有任何疑问，可向信悦臻选商城客服咨询。如果您不同意本协议或其中任何条款约定，请您立即停止注册或登录；您点击"同意"按钮后，本协议即构成对双方有约束力的法律文件。<br />
          一、定义<br />
          1、本站：在本协议中除非专门指明或声明，均指信悦臻选商城APP、小程序及微网站；在未经声明或特别指出的情况下，本站和荷鱼（北京）科技有限公司属于同一主体。<br />
          2、所有权以及相关的权利：在本服务协议中，除非专门指明或声明，均意味着：第一，所有权；第二，知识产权，包括但不限于著作权、专利权、商标权、商业秘密等；第三，除上述权利之外的对物、信息及其载体和表现形式的使用、利用、传播、复制、发行、编辑、修改、处分等权利。<br />
          3、用户：在本服务协议中，除非专门指明或声明，是指接受本服务协议的自然人、法人或其他组织。<br />
          4、个人信息：在本服务协议中，除非专门指明或声明，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别用户身份或者反映用户活动情况的各种信息。<br />
          5、网络服务：指本站基于互联网方式向用户提供的业务宣传、业务查询、商品交易等服务。<br />
          二、网络服务内容<br />
          1、本站向用户提供的网络服务包括：<br />
          （1）用户注册、登录、安全退出、基本资料修改、历史订单查询等服务；<br />
          （2）商品交易服务；<br />
          （3）短消息服务；<br />
          （4）本站为用户提供的其他服务。<br />
          2、本站有权根据情况变化调整网络服务的具体内容，本站提供的自助业务办理功能和商品信息随时都有可能发生变动，对此信悦臻选商城不作特别通知，也不对网络服务的提供或不提供作出承诺。<br />
          三、权利声明<br />
          1、任何本站所发布的信息及/或其载体，及/或其表现形式，及/或服务，除以下情况之外，其所有权及相关的权利均独占性地属于信悦臻选商城所有：<br />
          （1）依据中华人民共和国的相关法律规定该信息及/或载体，及/或服务，不享有所有权以及与此相关的权利的；<br />
          （2）依据信悦臻选商城和其他主体之间的协议、合同、章程，由信悦臻选商城和其他主体共享，或其他主体单独享有或信悦臻选商城转让的；<br />
          （3）依据信悦臻选商城具有法律效力的正式声明而放弃的。<br />
          2、用户只能在本站和内容提供者授权下才能使用由本站享有权利的内容，且无权擅自复制、修改这些内容，或创造与内容有关的派生产品。任何对本站享有的基于该信息及/或其载体，及/或其表现形式，及/或服务的权利的侵犯，均属于对本站权利的侵犯。<br />
          四、用户账号注册与管理<br />
          1、用户在完成注册或登录程序实际使用本系统提供服务时，应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若用户不具备前述主体资格，则用户及用户的监护人应当依照法律规定承担因此而导致的一切后果，信悦臻选商城有权注销或永久冻结您的账户。<br />
          2、您在本站设置的用户名不得违反国家法律法规关于互联网用户账号名称的管理规定，否则本站将有权回收您的用户名。用户名的回收不会影响您以邮箱、手机号码登录本站并使用本站服务。<br />
          3、您在本站的账号、密码和手机短信验证码是您在本站的唯一身份权证。为享受本系统提供的网络服务，您须按照对应的服务要求键入正确的用户账号及密码或短信验证码。<br />
          4、您应保管好自己在本站的账号、密码和手机短信验证码，避免使用过于简单的密码。您在服务使用过程中可以根据本站规定更改密码。非经本站事先同意，账号和密码不得出借、转让、继承或者赠与。非因本站原因导致您的账号、密码遗失、遗忘或被他人窃取的，本站不承担责任。如果您发现自己的个人信息泄密，尤其是本站账户及密码发生泄露，请您立即联络本站或信悦臻选商城。<br />
          5、用户通过账号+密码和/或短信验证码登录本系统进行的一切业务，均视为用户亲自办理的业务，由用户承担因此所导致的相关后果和责任，包括但不限于产品购买的支付。<br />
          6、信悦臻选商城将采取相应的措施来保证用户的帐户和交易安全，但信悦臻选商城不保证其绝对安全。；<br />
          五、用户权利及其限制<br />
          1、在遵守本服务协议的前提下，用户有权享有本站提供的网络服务，并将收到本站最新的优惠产品和服务的相关信息。如您不愿意接受本站的信息，您有权要求本系统停止向您发送产品和服务信息。<br />
          2、用户承诺对网络服务的使用应符合国家法律法规的规定，且行为符合下列要求：<br />
          （1）从中国境内向境外传输技术性资料时必须符合中国有关法律的规定；<br />
          （2）不传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；<br />
          （3）不传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；<br />
          （4）不得传输或发表违背公序良俗和涉及国家安全的信息资料或言论；<br />
          （5） 不干扰本站的正常运转，不得侵入本站及国家计算机信息系统；<br />
          （6）不得发布任何侵犯他人著作权、商标权等知识产权或隐私权、名誉权等合法权益的内容；<br />
          （7）遵守所有使用网络服务的网络协议、规定、程序和惯例；<br />
          （8）使用网络服务不作非法用途；<br />
          若用户未遵守以上规定的，须对自己在网上的言论和行为承担法律责任，且信悦臻选商城有权作出独立判断并采取暂停或关闭用户帐号服务等措施。<br />
          3、本站对用户发布及／或通过本站传送的任何内容不承担责任，用户需对自己在网上的行为承担一切法律责任。用户如在本系统发布涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，本站有权不经通知用户即予以删除。用户如有散布和传播反动、色情或其他违反国家法律信息的活动，本站的系统记录有可能作为用户违反法律的证据。<br />
          4、用户违反本协议使用网络服务导致本站或第三人损失的，因此产生的损害赔偿费用、律师费用及其他相关费用，均由该用户承担。<br />
          六、 商品购买<br />
          1、在您下订单购买商品时，请您仔细确认所购商品的名称、价格、数量、型号、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人/用户的行为和意思表示视为用户/收货人的行为和意思表示，用户/收货人应对收货人/用户的行为及意思表示的法律后果承担连带责任。<br />
          2、除法律另有强制性规定外，双方约定如下：本站中销售方展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售方发出的合同要约；销售方收到您的订单信息后，只有在销售方将您在订单中订购的商品从仓库实际直接向您发出时（以订单状态已发货为标志），方视为您与销售方之间就实际直接向您发出的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售方只给您发出了部分商品时，您与销售方之间仅就实际直接向您发出的商品建立了合同关系；只有在销售方实际直接向您发出了订单中订购的其他商品时，您和销售方之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登录您在本站注册的账户，查询您的订单状态。 由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品， 发生缺货，您有权取消订单。此等情况，并不视为信悦臻选商城违约，信悦臻选商城没有义务向您作出任何赔偿。<br />
          3、本站将会把商品送到您所指定的送货地址。所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库<br />
          （2）货物送达无人签收，由此造成的重复配送所产生的费用及相关的后果。<br />
          （3）不可抗力，例如：自然灾害、交通戒严、突发战争等。<br />
          （4）法定及特殊节假日期间，物流商无法正常配送的。<br />
          七、用户个人信息保护<br />
          1、 用户应保证自己在注册或登录时用户身份的真实性和正确性及完整性，如果相关信息发生变化，用户应及时更改。本系统不能也不会对个人信息的不真实、不准确，或个人信息未及时更新而引起的任何损失或损害承担责任。本站有权在投诉人准确说出用户在注册时所用的手机号码、身份证号码和用户姓名后删除该用户，并不承担任何责任。遇此情况，请用户重新注册。<br />
          2、用户未能按照本站的要求和内容提供本站要求的必要信息的，本站有权中止本站所提供的服务，由此所导致的任何已经或可能发生的损失，本站概不负责，并保留对该用户进行追索的权利。本站有权对用户的注册信息及相关操作进行查阅，发现注册信息或相关操作中存在任何问题或怀疑，均有权向用户发出询问及要求改正的通知或者直接作出删除账户等处理。<br />
          3、信悦臻选商城非常重视用户个人信息的保护，在您使用信悦臻选商城提供的网络服务时，您同意信悦臻选商城按照在本站公布的个人信息保护政策收集、存储、使用、披露和保护您的个人信息。信悦臻选商城希望通过《用户隐私政策》向您清楚地介绍信悦臻选商城对您个人信息的处理方式，因此建议您完整地阅读《用户隐私政策》，以帮助您更好地保护您的个人信息。<br />
          八、免责声明<br />
          1、本站不就通信系统或互联网的中断或无法运作、技术故障、计算机错误或病毒、信息损坏或丢失或其它在本站合理控制范围之外的原因而产生的其他任何性质的破坏而向用户或任何第三方承担赔偿责任。<br />
          2、本站需要定期或不定期地对相关的信息网络系统、设备进行检修、维护或升级，如因此类情况而造成网络服务在合理时间内的中断，本站无需为此承担任何责任，但本站将尽可能事先进行通知。<br />
          3、信悦臻选商城不保证用户在使用本站时在操作上不会中断或没有错误，不保证会纠正本站所有缺陷，不保证本站能满足用户的所有要求，亦不保证用户能通过本站订购所有信悦臻选商城的业务和产品，对网络服务的及时性、安全性、准确性也都不作担保。<br />
          4、用户通过本站进行交易、获取有偿服务而发生的所有税费及有关费用，均由用户负责支付，因此产生的风险也由用户个人承担。信悦臻选商城提醒用户应该通过自己的谨慎判断确定陈列商品及相关信息的真实性、合法性和有效性。<br />
          5、双方承认本条款反映了双方就协商谈判达成的一致意见。双方均完全了解本条款的后果并进一步承认本条款的合理性。<br />
          九、网络服务的停止<br />
          1、在以下情形下，本站有权单方并在不做出任何通知的情况下立即停止对用户提供网络服务:<br />
          （1）若该用户是通过手机号码及服务密码/或短信验证码登陆的，当该用户所对应的手机号码停机或销号后；<br />
          （2）用户违反本协议规定使用网络服务；<br />
          （3）用户提供的注册资料不真实；<br />
          （4）用户账户被删除后；<br />
          （5）若用户利用本站提供的邮件服务发送了垃圾邮件或其他有害信息，则本站有权停止为该用户提供邮件服务。<br />
          2、用户对本协议后续的修改有异议，或对本站的服务不满，可以行使如下权利：<br />
          （1）停止使用本站的网络服务；<br />
          （2）通告本站停止对该用户的服务；<br />
          3、用户服务停止后，本站没有义务向该用户或第三方传送任何未处理的信息或未完成的服务，亦无需对该用户或第三方负责。但本协议的终止并不意味着终止前所发生的未完成用户指令的撤销，也不能消除因终止前的交易所带来的法律后果。<br />
          十、通告<br />
          所有发给用户的通告都可通过页面的公告或电子邮件或常规的信件传送。服务条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。<br />
          十一、服务条款修改<br />
          本站有权根据法律法规变化和系统运营需要，对本协议条款不时地进行修改。本协议一旦发生变动，本站将通告用户，修改后的协议一经通告即生效。用户如果不同意所改动的内容，应主动停止使用本站提供的网络服务。如果用户继续享用本站网络服务，则视为接受服务条款的变动。<br />
          十二、法律<br />
          1、本协议条款适用中华人民共和国的法律法规。如协议条款与中华人民共和国法律相抵触，则依照法律的规定重新解释该服务条款，但不影响其它条款的法律效力和影响。<br />
          2、本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律并受中华人民共和国法院管辖。<br />
          3、用户与本站一致同意：<br />
          （1）双方应持平等、友好、争取合理解决问题的态度；<br />
          （2）发生纠纷时首先以协商方式解决，如协商未果，任何一方应向信悦臻选商城所在地人民法院提起诉讼。<br />
          十三、其他<br />
          1、信悦臻选商城未行使本协议的任何权利或规定，并不构成对前述权利之放弃。<br />
          2、如本协议中的任何条款完全或部分无效，本协议的其余条款仍有效并且有约束力。<br />
          3、本协议内容包括协议正文及本站上发布的声明和规则，包括但不限于购物指南、服务说明、个人信息保护政策等。所有声明、政策和规则等与协议正文具有同等法律效力，共同构成完整的系统服务协议<br />
          本协议有效期：2025年8月26日起长期有效`
      },
      {
        ids: 10,
        title: "入驻经营者规范",
        des: `一、入驻资质
          1. 入驻经营者必须提供真实、有效的营业执照、税务登记证、组织机构代码证等相关证件，且证件信息应与实际经营情况相符。若发现营业执照过期或经营范围与实际经营不符，平台有权拒绝入驻或要求整改。<br />
          2. 具备合法的经营许可，如食品经营许可证、医疗器械经营许可证等（根据经营类目而定）。<br />
          从事食品销售的入驻者，必须持有有效的食品经营许可证，且所售食品应在许可证许可范围内。<br />
          二、商品与服务质量<br />
          1. 所售商品必须符合国家相关质量标准，严禁销售假冒伪劣、过期、变质商品。对于电子产品，应符合国家强制性认证标准；对于服装，应符合相应的纤维含量、色牢度等标准。<br />
          2. 提供优质的服务，包括及时回复顾客咨询、有效处理售后问题等。客咨询应在 24 小时内回复，售后问题应在 7 个工作日内解决。<br />
          三、诚信经营<br />
          1. 严禁虚假宣传，包括但不限于夸大商品功效、虚假促销等。2. 遵守价格法律法规，不得进行价格欺诈。<br />
          四、数据与信息安全<br />
          1. 入驻经营者应妥善保管顾客的个人信息，不得泄露、滥用。<br />
          2. 按照平台规定进行数据统计和报送，确保数据的真实性和准确性。<br />
          五、知识产权保护<br />
          1. 不得侵犯他人的商标权、专利权、著作权等知识产权。<br />
          2. 对于涉及知识产权纠纷的商品，应积极配合平台的调查和处理。<br />
          六、违规处理<br />
          1. 平台将对入驻经营者的违规行为进行监督和检查，一旦发现违规，将视情节轻重采取警告、罚款、暂停营业、关闭店铺等处理措施。<br />
          2. 入驻经营者对处理结果有异议的，可在规定时间内提出申诉，平台将进行复查。<br />
          七、附则<br />
          1. 本规范自发布之日起生效，平台有权根据法律法规和业务发展需要进行修改和完善。<br />
          2. 入驻经营者应关注平台的通知，及时了解规范的更新内容。<br />
          本协议有效期：2025年8月26日起长期有效`
      },
      {
        ids: 11,
        title: "用户交易纠纷处理机制",
        des: ` 一、纠纷受理<br />
          1. 用户可以通过平台内的专门渠道（如纠纷投诉入口、客服热线等）提交交易纠纷申诉。<br />
          2. 平台在接到申诉后的 24 小时内确认受理，并向用户发送受理通知。<br />
          二、证据收集<br />
          1. 要求用户和相关经营者在规定时间内（通常为 48 小时）提供与纠纷相关的证据，如订单信息、聊天记录、商品照片等。<br />
          2. 平台自身也会调取交易过程中的相关数据和记录，作为判断的参考。<br />
          三、纠纷调解<br />
          1. 由专业的纠纷处理团队对收集到的证据进行审查和分析。<br />
          2. 尝试通过电话、在线沟通等方式与双方进行调解，了解双方的诉求和意见。<br />
              - 例如，如果是商品质量问题导致的纠纷，调解团队会根据商品的损坏程度和相关标准，提出合理的解决方案，如退款、换货或部分赔偿。<br />
          四、判定与裁决<br />
          1. 在调解无果的情况下，依据平台规则和相关法律法规，在 7 个工作日内做出判定和裁决。<br />
          2. 判定结果以书面形式通知双方，并说明判定的依据和理由。<br />
          五、执行与监督<br />
          1. 对于判定的结果，要求责任方在规定时间内执行。<br />
              - 比如，若判定商家退款，商家需在 3 个工作日内完成退款操作。<br />
          2. 平台对执行情况进行监督，确保判定结果得到有效落实。<br />
          六、申诉与复查<br />
          1. 若一方对判定结果不满意，可以在 5 个工作日内提出申诉。<br />
          2. 平台会重新组织人员对申诉进行复查，复查结果为最终结果。<br />
          七、信息保密<br />
          在处理纠纷过程中，严格保护用户和经营者的个人信息和商业秘密，确保不被泄露。<br />
          八、数据分析与改进<br />
          定期对交易纠纷数据进行分析，总结常见问题和原因，针对性地改进平台规则和服务流程，以减少纠纷的发生。<br />
          本协议有效期：2025年8月26日起长期有效`
      },
    ]
  },
  {
    id: 3,
    title: "售后服务",
    list: [
      {
        ids: 12,
        title: "退换货服务",
        des: `买家可以先联系卖家客服，并提供实物图片确认问题是否属实。如果确认商品问题，或无法说明商品是否合格，卖家应与买家协商解决；若因商品问题商家拒绝处理，可以要求信悦臻选客服介入处理。`
      },
    ]
  },
  {
    id: 4,
    title: "商家帮助",
    list: [
      {
        ids: 12,
        title: "商家入驻材料",
        des: `商家注册地址：<a target="_blank" href="https://admin.xinyuemall.com/index/user/register.html?url=" >https://admin.xinyuemall.com/index/user/register.html?url=</a><br />
          商家注册资料：邮箱、用户名、密码、手机号<br />
          店铺申请材料：<br />
          个人店铺：<br />
          1、主体信息<br />
          姓名：个人姓名<br />
          身份证号：个人身份证号<br />
          手持身份证：上传手持身份证拍照照片<br />
          微信号<br />
          2、店铺信息<br />
          店铺名称<br />
          店铺图标<br />
          店铺简介<br />
          经营地址<br />
          店铺介绍<br />
          企业店铺：<br />
          1、主体信息<br />
          企业名称<br />
          上传营业执照<br />
          微信号<br />
          2、店铺信息<br />
          店铺名称<br />
          店铺图标<br />
          店铺简介<br />
          经营地址<br />
          店铺介绍<br />
          旗舰店：<br />
          1、主体信息<br />
          企业名称<br />
          上传营业执照<br />
          上传商标证书<br />
          微信号<br />
          2、店铺信息<br />
          店铺名称<br />
          店铺图标<br />
          店铺简介<br />
          经营地址<br />
          店铺介绍`
      },
    ]
  },
]

export {
  leftList
};
